module.exports = __webpack_public_path__ + "img/framenew_box30.16af6997.jpg";